import React, { ReactNode } from "react";
import { Button, Modal, Card, Row, Col } from "react-bootstrap";

type ModelTypeModalProps = {
    show: boolean,
    onClose: () => void,
    onSelectClassic: () => void,
    onSelectDynamic: () => void
}

export default class ModelTypeModal extends React.Component<ModelTypeModalProps> {
    public render(): ReactNode {
        return (
            <Modal show={this.props.show} onHide={this.props.onClose} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Choose Model Type</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Select the type of model you want to create:</p>
                    <Row>
                        <Col md={6}>
                            <Card 
                                className="mb-3" 
                                style={{ cursor: "pointer", height: "100%" }}
                                onClick={this.props.onSelectClassic}
                            >
                                <Card.Body>
                                    <Card.Title>Classic Model</Card.Title>
                                    <Card.Text>
                                        Traditional model that references a slot configuration.
                                        The slot defines the scoring factors, filters, and field affinities.
                                    </Card.Text>
                                    <Button variant="primary" onClick={this.props.onSelectClassic}>
                                        Create Classic Model
                                    </Button>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={6}>
                            <Card 
                                className="mb-3" 
                                style={{ cursor: "pointer", height: "100%" }}
                                onClick={this.props.onSelectDynamic}
                            >
                                <Card.Body>
                                    <Card.Title>Dynamic Model</Card.Title>
                                    <Card.Text>
                                        Advanced model with custom configuration.
                                        Define unique scoring factors, filters, and field affinities for this model.
                                    </Card.Text>
                                    <Button variant="success" onClick={this.props.onSelectDynamic}>
                                        Create Dynamic Model
                                    </Button>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.props.onClose}>
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

